<template>
  <div id="FinalRemarkForm">
    <div class="modal-card fixed-width">
      <!-- Modal Title -->
      <header class="modal-card-head">
        <p class="modal-card-title">Recommendation Note</p>
      </header>
      <!-- Modal Description + Input -->
      <section class="modal-card-body">
        <div class="media">
          <div class="media-content">
            <!-- Modal Description -->
            <p class="subtitle is-6">
              Please input any recommendations, action plans or remarks...
            </p>
            <!-- Modal Input Field -->
            <b-field>
              <b-input
                required
                custom-class="prompt-font"
                type="textarea"
                maxlength="200"
                v-model="recommendation_note"
                placeholder="คำแนะนำจากเรา"
              />
            </b-field>
          </div>
        </div>
      </section>
      <!-- Modal Footer -->
      <footer class="modal-card-foot" style="justify-content: flex-end;">
        <b-button
          v-if="edited"
          outlined
          class="prompt-font"
          type="is-primary"
          @click.prevent="updateFactInfoState()"
        >
          บันทึก
        </b-button>
        <!-- Button: Save -->
        <b-button
          v-else
          class="prompt-font"
          type="is-primary"
          :disabled="disableSaveFactsheet"
          @click.prevent="saveFactInfoState()"
        >
          ยืนยัน
        </b-button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "FinalRemarkForm",
  props: ["edited"],
  computed: {
    ...mapState(["factsheet_remark"]),
    disableSaveFactsheet: function() {
      if (this.recommendation_note && this.recommendation_note !== "") {
        return false;
      } else {
        return true;
      }
    }
  },
  data() {
    return {
      recommendation_note: null
    };
  },
  methods: {
    ...mapMutations({
      setFactSheetRemark: "SET_FACTSHEET_REMARK"
    }),
    saveFactInfoState: function() {
      if (!this.disableSaveFactsheet) {
        let plan_summary = this.createFactInfoSummaryObject();
        this.setFactSheetRemark(plan_summary);
        this.$emit("completed_form");
        this.$emit("close");
      }
    },
    updateFactInfoState: function() {
      if (this.edited) {
        let plan_summary = this.createFactInfoSummaryObject();
        this.setFactSheetRemark(plan_summary);
        this.$emit("existing_sheet_updated");
        this.$emit("close");
      }
    },
    createFactInfoSummaryObject: function() {
      const plan_summary = {
        recommendation_note: this.recommendation_note
      };
      return plan_summary;
    }
  },
  beforeMount() {
    if (this.edited) {
      this.recommendation_note = this.factsheet_remark.recommendation_note;
    }
  }
};
</script>

<style scoped>
.fixed-width {
  max-width: 420px;
  padding: 0 20px;
}
</style>
